import BOMB_BOMB_IMAGE_URL from './bomb.png';
export { BOMB_BOMB_IMAGE_URL };
export const BOMB_BOMB_SPRITESHEET_DATA = {
    frames: {
        'bomb0001.png': {
            frame: { x: 1, y: 1, w: 191, h: 161 },
            rotated: false,
            trimmed: false,
            spriteSourceSize: { x: 0, y: 0, w: 191, h: 161 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        },
        'bomb0002.png': {
            frame: { x: 1, y: 1, w: 191, h: 161 },
            rotated: false,
            trimmed: false,
            spriteSourceSize: { x: 0, y: 0, w: 191, h: 161 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        },
        'bomb0003.png': {
            frame: { x: 369, y: 1, w: 172, h: 155 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 6, w: 172, h: 155 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        },
        'bomb0004.png': {
            frame: { x: 369, y: 1, w: 172, h: 155 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 6, w: 172, h: 155 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        },
        'bomb0005.png': {
            frame: { x: 543, y: 1, w: 162, h: 153 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 8, w: 162, h: 153 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        },
        'bomb0006.png': {
            frame: { x: 543, y: 1, w: 162, h: 153 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 8, w: 162, h: 153 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        },
        'bomb0007.png': {
            frame: { x: 194, y: 1, w: 173, h: 155 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 6, w: 173, h: 155 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        },
        'bomb0008.png': {
            frame: { x: 194, y: 1, w: 173, h: 155 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 6, w: 173, h: 155 },
            sourceSize: { w: 191, h: 161 },
            anchor: { x: 0.325459, y: 0.619938 }
        }
    },
    animations: {
        animation: [
            'bomb0001.png',
            'bomb0002.png',
            'bomb0003.png',
            'bomb0004.png',
            'bomb0005.png',
            'bomb0006.png',
            'bomb0007.png',
            'bomb0008.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.0',
        image: BOMB_BOMB_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 706, h: 163 },
        scale: '0.5',
        smartupdate: '$TexturePacker:SmartUpdate:9a0c46cfb5d0d0703a3db0abc425564d:c9be583c446bbbed4b73947d62258a72:f63ee348f1e457e41f792cb710b5b64f$'
    }
};
